import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3cf8e58d&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DateDayPager: require('/home/runner/work/myody_front/myody_front/components/date/DateDayPager.vue').default,GoodsOdgItem: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdgItem.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
